import { defineMessages } from 'react-intl';

export const selectionModeMessages = defineMessages({
  selectedNumOfProducts: {
    id: 'wishlist.selectionMode.selectedNumOfProducts',
    defaultMessage: 'Pocet vybranych produktu: {count}',
  },
  moveButton: {
    id: 'wishlist.selectionMode.moveButton',
    defaultMessage: 'Presunout',
  },
  removeButton: {
    id: 'wishlist.selectionMode.removeButton',
    defaultMessage: 'Odstranit',
  },
  removeProductsFromListDrawerTitle: {
    id: 'wishlist.selectionMode.removeProductsFromList.drawerTitle',
    defaultMessage: 'Odstranit produkty',
  },
  removeProductsFromListDrawerText: {
    id: 'wishlist.selectionMode.removeProductsFromList.drawerText',
    defaultMessage:
      'Produkty budou odstraněny z vašeho seznamu {listName} a tuto akci již nebude možné vrátit zpět.',
  },
  removeProductsFromListDrawerYesButton: {
    id: 'wishlist.selectionMode.removeProductsFromList.drawerYesButton',
    defaultMessage: 'Ano, chci odstranit',
  },
  removeProductsFromListDrawerNoButton: {
    id: 'wishlist.selectionMode.removeProductsFromList.drawerNoButton',
    defaultMessage: 'Ne, děkuji',
  },
  removedProductsToastText: {
    id: 'wishlist.selectionMode.removedProductsToastText',
    defaultMessage:
      'Odstranili jste vybrané produkty ze seznamu <b>{listName}</b>.',
  },
  moveSaveButton: {
    id: 'wishlist.selectionMode.moveSaveButton',
    defaultMessage: 'Přesunout',
  },
  createAndMoveSaveButton: {
    id: 'wishlist.selectionMode.createAndMoveSaveButton',
    defaultMessage: 'Vytvořit a přesunout',
  },
});
